import type { FC } from "react";

import type {
  TCatOverviewDetailProps,
} from "@/ui/components/data-display/Card/CatOverviewCard/CatOverviewCard.config";
import { Container, Flex } from "@/ui/components/layout";
import { Icon } from "@/ui/components/primitives";
import { TextBody } from "@/ui/components/typography/TextBody";

export const CatOverviewDetail: FC<TCatOverviewDetailProps> = ({ icon, label, value }) => (
  <Flex data-component="CatOverviewDetail" className="py-1" align="center" gap="1.5" aria-label={label}>
    <Container className="size-6 flex items-center justify-center rounded-full bg-sys-black-50">
      <Icon icon={icon} size="sm" aria-hidden="true" />
    </Container>
    <TextBody size={2} isResponsive={false}>{ value }</TextBody>
  </Flex>
);

CatOverviewDetail.displayName = "CatOverviewDetail";
